import React, { useState, useRef, useEffect } from "react";
import { isTokenExpired, willExpireSoon } from './TokenUtils';
export const useSessionWatcher = ({
    getToken,
    onExpire,
    onRefresh,
    onPreIdleWarning,
  }) => {

    const [idle, setIdle] = useState(false);
    const [warned, setWarned] = useState(false);
    const lastActivityRef = useRef(Date.now());
    // const MAX_IDLE_MS = 15 * 60 * 1000;
    // const PRE_IDLE_MS = 1 * 60 * 1000;
    // const CHECK_INTERVAL = 5* 60* 1000; // 5 minutes

    const MAX_IDLE_MS = 60 * 60 * 1000;
    const PRE_IDLE_MS = 50 * 60 * 1000;
    const CHECK_INTERVAL = 5 * 60 * 1000; 

    const triggerActivity = () => {
        lastActivityRef.current = Date.now();
        setIdle(false);
        setWarned(false);
      };



      useEffect(() => {
        const handleActivity = () => {
          triggerActivity();
        };
    
        const events = ['mousemove', 'keydown', 'mousedown', 'touchstart'];
        events.forEach((e) => window.addEventListener(e, handleActivity));
        return () => events.forEach((e) => window.removeEventListener(e, handleActivity));
      }, []);
  


      
     useEffect(() => {
      const interval = setInterval(() => {
        const now = Date.now();
        const since = now - lastActivityRef.current;
  
        const token = getToken();

        if (!token) return;

        //TODO in future
  //enable need for trackig inactivity and expire session when needed 
        // if (since > MAX_IDLE_MS) {  //if idel more than x session timeout 
        //   setIdle(true);
        //   onExpire?.();
        //   return;
        // }
  //avoid force out.
        // if (!warned && since > MAX_IDLE_MS - PRE_IDLE_MS && since <= MAX_IDLE_MS) {
        //   setWarned(true);
        //   onPreIdleWarning?.();
        // }
  
        if (isTokenExpired(token)) {
          onExpire?.();
        } else if (willExpireSoon(token)) {
          onRefresh?.();
        }
      }, CHECK_INTERVAL);
  
      return () => clearInterval(interval);
    }, [getToken, onExpire, onRefresh, warned, idle, onPreIdleWarning]);

    return { triggerActivity }; // 👈 expose this
  };
